<template>
  <DBox
    :id="'cmp-catalog-releases-sidewindow-related_tracks'"
    :addButton="false"
    :addLink="false"
    :addLinkLabel="`${$t('add_new')} ${$t('related_track')}`"
    @add_click="onAddGenres"
  >
    <NTable
      class="dbox1"
      id="catalog-releases-sidewindow-related_tracks"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('related_tracks')">
            <!-- <span class="ut-link ut-text-accent5"></span> -->
            <v-menu
              :close-on-content-click="false"
              open-on-hover
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="100px"
            >
              <span
                @click="onTrackClick(item)"
                class="ut-link ut-text-accent5"
                slot="activator"
              >
                {{ getConcatTitle(item) }}
              </span>
              <div class="cmp-catalog-releases-sidewindow-hover_div">
                <p>Artist: {{ item.artist }}</p>
                <p>Title : {{ getConcatTitle(item) }}</p>
                <p>Version : {{ item.version }}</p>
                <p>Playtime : {{ item.playtime }}</p>
                <p style="margin-bottom:16px">Isrc : {{ item.isrc }}</p>
                <p>Composer: {{ item.composer }}</p>
                <p>Writer : {{ item.writer }}</p>
                <p>Producer : {{ item.producer }}</p>
                <p>Publisher : {{ item.publisher }}</p>
                <!-- <div class="amount-text">{{item['gross_amount_cc']}}</div>
                              <div class="amount-currency">{{item['currency_iso']}}</div> -->
              </div>
            </v-menu>
          </td>
          <td v-bind="tdcon('artist')">
            <span>{{ item["artist"] }}</span>
          </td>
          <td v-bind="tdcon('isrc')">
            <span>{{ item["isrc"] }}</span>
          </td>
          <td v-bind="tdcon('options')">
            <TrackType
              v-if="item['type']"
              style="padding: 1px 5px;font-size: 11px;"
              :type="item['type']"
            />
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { TrackType } from "../../../../dt-plugins/tracks/track-type";
import { tracksListLDTRoutes } from "../../router/routes";
export default {
  props: {
    selectedReleaseDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox,
    TrackType
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },
      releaseArtist: "",
      releaseTitle: "",
      releaseDate: "",
      releaseCode: "",
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      })
    };
  },
  computed: {
    Headers: function() {
      return [
        createTableHeader("related_tracks", {mw:250,}),
        createTableHeader("artist", {mw:250,}),
        createTableHeader("isrc", {}),

        createTableHeader("options", { text: false, mw: 70 })
      ];
    },

    list: function() {
      return this.selectedReleaseDetails.tracks_only || [];
    }
  },

  methods: {
    onTextFieldValueChange: function() {},

    getConcatTitle:function(item){
      if(item.version && item.version.length>0){
        return `${item['title']} (${item['version']})`;
      }

      return item['title']||'';
    },


    getTypeInitial(str) {
      if (str) {
        return str.charAt(0).toUpperCase();
      }

      return "N";
    },
    onDropdownChange: function(item, e) {
      console.log("ITEM GENRE ENK", e);
      const payload = {
        name: "genre_relation_rank",
        value: e.value,
        item: item
      };

      this.$emit("change", payload);
    },
    onDateChange: function() {},
    deleteFile: function(item) {
      const payload = {
        file_id: item.file_id,
        file_relation_id: item.file_relation_id
      };
      this.$emit("delete", payload);
      console.log("Genres", item);
    },
    onAddGenres: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_genre",
          external_id: this.selectedReleaseDetails.release.release_id
        }
      });
    },
    onTrackClick: function(item) {
      console.log(item);
      this.$router.push({
        name: tracksListLDTRoutes.names.tab,
        params: {
          track_id: item.track_id,
          tab: "overview"
        }
      });
    }
  }
};
</script>
<style lang="scss">
.cmp-catalog-releases-sidewindow-related_tracks {
  .i-icon-box {
    border: 1px solid white;
    background-color: var(--emerald);
    color: white;
    font-weight: 400;
    display: grid;
    place-items: center;
  }
}

.cmp-catalog-releases-sidewindow-hover_div {
  padding: 10px;
  background: white;
  p {
    margin-bottom: 0px;
  }
}
</style>
